import { BasicTopNav } from '../../components/topNav';
import { PrivacyFooter } from '../../components/footer';
import Layout from './Layout';

type BasicLayoutProps = {
  withPrivacy?: boolean;
  withLogo?: React.ReactNode;
  children?: React.ReactNode;
};

function BasicLayout({
  withPrivacy = true,
  withLogo,
  children,
}: BasicLayoutProps): JSX.Element {
  return (
    <Layout>
      <BasicTopNav withLogo={withLogo} />
      {children}
      {withPrivacy && <PrivacyFooter />}
    </Layout>
  );
}

export default BasicLayout;
